import { Box, InlineBanner } from '@cad-arc';
import { useEsriEmbeddedBaseMap } from '../esri/base-maps/use-esri-embedded-base-map';
import { useSingleGraphicDisplayLayer } from '../esri/hooks/use-single-graphic-display-layer';
import { GeoPoint } from '../location/types';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { observer } from 'mobx-react-lite';

export const LocationRadiusSearchMap = observer(function LocationRadiusSearchMap({
    center,
    radiusInFeet,
}: Readonly<{
    center: GeoPoint;
    radiusInFeet: number;
}>) {
    const { mapView, mapComponent, isMapLoadingFailed } = useEsriEmbeddedBaseMap({
        center,
        surface: 'location-radius-search',
    });
    useSingleGraphicDisplayLayer({ mapView, center, radiusInFeet });

    return (
        <Box w="250px" h="250px">
            {isMapLoadingFailed ? (
                <InlineBanner status="error" description={errorOccurredWhile('loading the map')} />
            ) : (
                mapComponent
            )}
        </Box>
    );
});
